module.exports = __webpack_public_path__ + "img/in.c8e98484.svg";